export const localizeText = (text) => {
  const lang = localStorage.getItem("lang");
  const res = text?.[lang === "en" || !lang ? "default" : lang];
  return !!res ? res : text?.["default"];
};
